import type { UIMessage } from '../../types';
import { IconPlay } from '../web/icons';
import { ImFileCard } from './ImFileCard';

export interface LightboxTarget {
  type: 'image' | 'video';
  url: string;
  name?: string;
}

/**
 * 消息气泡内部内容渲染 —— 文本 / 图片缩略图 / 视频缩略图 / 文件卡片,末尾流式光标。
 * 从 WebChatPanel 抽出,web 客服与数字人客服共用(复用 dcs-web-media-* / dcs-cursor 样式)。
 *
 * - 图片/视频点击触发 onOpenLightbox(交由父组件管理 MediaLightbox 遮罩,放在 transform 包含块外)。
 * - text 可由父组件覆盖:数字人按音频时长逐字时传 displayText;web/普通消息缺省取 msg.text。
 */
export function MessageContent({
  msg,
  t,
  onOpenLightbox,
  text,
}: {
  msg: UIMessage;
  t: (key: string) => string;
  onOpenLightbox: (target: LightboxTarget) => void;
  text?: string;
}) {
  const shownText = text ?? msg.text;
  return (
    <>
      {msg.msgType === 'image' ? (
        msg.fileUrl ? (
          <img
            src={msg.fileUrl}
            alt={msg.fileName || ''}
            class="dcs-web-media-img"
            title={t('web.viewImage')}
            onClick={() =>
              onOpenLightbox({ type: 'image', url: msg.fileUrl!, name: msg.fileName })
            }
          />
        ) : (
          <span>{msg.fileName || '🖼️'}</span>
        )
      ) : msg.msgType === 'video' ? (
        msg.fileUrl ? (
          <button
            type="button"
            class="dcs-web-media-video"
            aria-label={t('web.playVideo')}
            onClick={() =>
              onOpenLightbox({ type: 'video', url: msg.fileUrl!, name: msg.fileName })
            }
          >
            {/* #t=0.1 让浏览器跳到首帧渲染缩略图(fragment 不入签名,不影响 OSS 鉴权) */}
            <video src={`${msg.fileUrl}#t=0.1`} preload="metadata" muted playsInline />
            <span class="dcs-web-media-play" aria-hidden="true">
              <IconPlay size={22} />
            </span>
          </button>
        ) : (
          <span>{msg.fileName || '🎬'}</span>
        )
      ) : msg.msgType === 'file' ? (
        <ImFileCard msg={msg} t={t} />
      ) : (
        shownText
      )}
      {msg.streaming && <span class="dcs-cursor" aria-hidden="true">|</span>}
    </>
  );
}
